import * as v from "vue";
import { reactive as I, computed as l, onMounted as C, onUnmounted as $ } from "vue";
import * as r from "vue-i18n";
import { isVue2 as w } from "vue-demi";
const u = 600, m = 1200, i = {
  desktop: {
    minWidth: m
  },
  tablet: {
    minWidth: u,
    maxWidth: m
  },
  mobile: {
    maxWidth: u
  }
};
function fe() {
  const a = I({
    width: null
  }), e = l(() => a.width >= i.desktop.minWidth), o = l(() => a.width >= i.tablet.minWidth && a.width < i.tablet.maxWidth), t = l(() => a.width < i.mobile.maxWidth);
  function n() {
    a.width = window.innerWidth;
  }
  function x() {
    window.addEventListener("resize", n);
  }
  function f() {
    window.removeEventListener("resize", n);
  }
  return C(() => {
    n(), x();
  }), $(f), { isDesktop: e, isTablet: o, isMobile: t };
}
const F = {
  actions: {
    close: "Clique aqui para fechar o alerta."
  }
}, q = {
  actions: {
    openMenu: "Clique aqui para visualizar todos os links."
  }
}, y = {
  actions: {
    close: "Clique aqui para ocultar as informações.",
    open: "Clique aqui para exibir as informações."
  }
}, S = {
  placeholder: "Selecionar arquivo"
}, k = {
  actions: {
    edit: {
      title: "Clique aqui para editar {label}"
    },
    cancel: {
      title: "Clique aqui para cancelar a edição {label}"
    },
    save: {
      title: "Clique aqui para salvar a edição {label}"
    }
  }
}, E = {
  actions: {
    close: "Clique aqui para fechar o modal."
  }
}, M = {
  aria: {
    label: "Páginas para navegação."
  },
  next: "Ir para próxima página.",
  prev: "Ir para página anterior."
}, B = {
  actions: {
    select: {
      ellipsis: "Selecione...",
      all: "Selecionar todos"
    },
    search: "Buscar"
  },
  searchEmpty: "Nenhum resultado encontrado."
}, N = {
  loading: "Carregando..."
}, P = {
  actions: {
    close: "Clique aqui para fechar."
  }
}, X = {
  errors: {
    required: "O campo é obrigatório",
    phone: "Digite um telefone válido",
    email: "Informe um e-mail válido",
    cnpj: "Informe um CNPJ válido",
    cpf: "Informe um CPF válido",
    document: "Informe um documento válido",
    date: "Informe uma data válida",
    fullName: "Utilize nome e sobrenome",
    dateInThePast: "Deve ser anterior à data atual"
  }
}, z = {
  shortNumeric: {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  },
  short: {
    year: "numeric",
    month: "short",
    day: "numeric"
  }
}, W = {
  actions: {
    edit: {
      base: "Editar"
    },
    cancel: {
      base: "Cancelar"
    },
    save: {
      base: "Salvar"
    }
  },
  badge: {
    new: "Novo",
    beta: "Beta"
  }
}, D = {
  currency: {
    style: "currency",
    currency: "BRL",
    notation: "standard"
  },
  decimal: {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
}, c = {
  messages: {
    ds: {
      xAlert: F,
      XBreadCrumb: q,
      xCollapse: y,
      XFileInput: S,
      xInlineEdit: k,
      xModal: E,
      xPagination: M,
      xSelect: B,
      xSpinner: N,
      xTooltip: P,
      validations: X,
      global: W
    }
  },
  datetimeFormats: z,
  numberFormats: D
}, L = {
  actions: {
    close: "Click here to close the alert."
  }
}, T = {
  actions: {
    openMenu: "Click here to see all links."
  }
}, U = {
  actions: {
    close: "Click here to hide the information.",
    open: "Click here to show the information."
  }
}, H = {
  placeholder: "Select file"
}, R = {
  actions: {
    edit: {
      title: "Click here to edit {label}"
    },
    cancel: {
      title: "Click here to cancel the edit {label}"
    },
    save: {
      title: "Click here to save the edit {label}"
    }
  }
}, A = {
  actions: {
    close: "Click here to close the modal."
  }
}, j = {
  aria: {
    label: "Navigation pages."
  },
  next: "Go to next page.",
  prev: "Go to previous page."
}, G = {
  actions: {
    select: {
      ellipsis: "Select...",
      all: "Select all"
    },
    search: "Search"
  },
  searchEmpty: "No results found."
}, V = {
  loading: "Loading..."
}, J = {
  actions: {
    close: "Click here to close."
  }
}, O = {
  errors: {
    required: "This field is required",
    phone: "Enter a valid phone number",
    email: "Enter a valid email address",
    cnpj: "Enter a valid CNPJ",
    cpf: "Enter a valid CPF",
    document: "Enter a valid document",
    date: "Enter a valid date",
    fullName: "Use both first and last names",
    dateInThePast: "Must be before the current date"
  }
}, K = {
  shortNumeric: {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  },
  short: {
    year: "numeric",
    month: "short",
    day: "numeric"
  }
}, Q = {
  actions: {
    edit: {
      base: "Edit"
    },
    cancel: {
      base: "Cancel"
    },
    save: {
      base: "Save"
    }
  },
  badge: {
    new: "New",
    beta: "Beta"
  }
}, Y = {
  currency: {
    style: "currency",
    currency: "USD",
    notation: "standard"
  },
  decimal: {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
}, s = {
  messages: {
    ds: {
      xAlert: L,
      XBreadCrumb: T,
      xCollapse: U,
      XFileInput: H,
      xInlineEdit: R,
      xModal: A,
      xPagination: j,
      xSelect: G,
      xSpinner: V,
      xTooltip: J,
      validations: O,
      global: Q
    }
  },
  datetimeFormats: K,
  numberFormats: Y
}, Z = {
  actions: {
    close: "Haz click aquí para cerrar la alerta."
  }
}, _ = {
  actions: {
    openMenu: "Haz click aquí para ver todos los enlaces."
  }
}, ee = {
  actions: {
    close: "Haz click aquí para ocultar la información.",
    open: "Haz click aquí para mostrar la información."
  }
}, ae = {
  placeholder: "Seleccionar archivo"
}, te = {
  actions: {
    edit: {
      title: "Haz click aquí para editar {label}"
    },
    cancel: {
      title: "Haz click aquí para cancelar la edición de {label}"
    },
    save: {
      title: "Haz click aquí para guardar la edición de {label}"
    }
  }
}, ne = {
  actions: {
    close: "Haz click aquí para cerrar la ventana."
  }
}, oe = {
  aria: {
    label: "Páginas para navegación web."
  },
  next: "Ir a la siguiente página.",
  prev: "Ir a la página anterior."
}, ie = {
  actions: {
    select: {
      ellipsis: "Seleccionar...",
      all: "Seleccionar todos"
    },
    search: "Buscar"
  },
  searchEmpty: "No se encontraron resultados."
}, re = {
  loading: "Cargando..."
}, le = {
  actions: {
    close: "Haz click aquí para cerrar."
  }
}, ce = {
  errors: {
    required: "El campo es obligatorio",
    phone: "Ingresa un teléfono válido",
    email: "Ingresa un correo electrónico válido",
    cnpj: "Ingresa un CNPJ válido",
    cpf: "Ingresa un CPF válido",
    document: "Ingresa un documento válido",
    date: "Ingresa una fecha válida",
    fullName: "Utiliza nombre y apellido",
    dateInThePast: "Debe ser anterior a la fecha actual"
  }
}, se = {
  shortNumeric: {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  },
  short: {
    year: "numeric",
    month: "short",
    day: "numeric"
  }
}, de = {
  actions: {
    edit: {
      base: "Editar"
    },
    cancel: {
      base: "Cancelar"
    },
    save: {
      base: "Guardar"
    }
  },
  badge: {
    new: "Nuevo",
    beta: "Beta"
  }
}, ue = {
  currency: {
    style: "currency",
    currency: "MXN",
    notation: "standard"
  },
  decimal: {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
}, d = {
  messages: {
    ds: {
      xAlert: Z,
      XBreadCrumb: _,
      xCollapse: ee,
      XFileInput: ae,
      xInlineEdit: te,
      xModal: ne,
      xPagination: oe,
      xSelect: ie,
      xSpinner: re,
      xTooltip: le,
      validations: ce,
      global: de
    }
  },
  datetimeFormats: se,
  numberFormats: ue
}, me = {
  "pt-BR": c.messages,
  "en-US": s.messages,
  "es-MX": d.messages
}, b = {
  "pt-BR": c.datetimeFormats,
  "en-US": s.datetimeFormats,
  "es-MX": d.datetimeFormats
}, pe = {
  "pt-BR": c.numberFormats,
  "en-US": s.numberFormats,
  "es-MX": d.numberFormats
};
window.$excalibur = window.$excalibur || {};
const p = "pt-BR";
function h() {
  return {
    locale: p,
    fallbackLocale: {
      enUs: ["en-US"],
      en: ["en-US"],
      esMx: ["es-MX"],
      default: [p]
    },
    messages: me,
    numberFormats: pe
  };
}
function g(a) {
  var e;
  (e = window.$excalibur) != null && e.locale || (window.$excalibur.locale = a);
}
function be() {
  const a = r == null ? void 0 : r.default;
  v.default.use(a);
  const e = new a({
    ...h(),
    dateTimeFormats: b,
    silentFallbackWarn: !0
  });
  function o(t) {
    e.locale = t;
  }
  g({
    useI18n: {
      t: (t, ...n) => e.t(t, ...n),
      tc: (t, ...n) => e.tc(t, ...n),
      d: (t, ...n) => e.d(t, ...n),
      n: (t, ...n) => e.n(t, ...n),
      setLocale: o
    },
    i18n: e
  });
}
function he() {
  const { createI18n: a } = r, e = a({
    ...h(),
    legacy: !1,
    globalInjection: !0,
    fallbackWarn: !1,
    missingWarn: !1,
    datetimeFormats: b
  });
  function o(n) {
    e.global.locale.value = n;
  }
  const { t } = e.global;
  g({
    useI18n: {
      ...e.global,
      tc: t,
      setLocale: o
    },
    i18n: e
  });
}
function ve() {
  var a;
  return (a = window.$excalibur) == null ? void 0 : a.locale;
}
function Ie() {
  var e;
  (e = window.$excalibur) != null && e.locale || (w ? be() : he());
  const { useI18n: a } = window.$excalibur.locale;
  return a;
}
export {
  ve as getLocaleInstance,
  fe as useBreakpoints,
  Ie as useI18n
};
